import React from 'react';
import { cn } from '../../utils/cn';
import type { BaseComponentProps } from '../../types/common';

export interface LabelProps extends BaseComponentProps {
  htmlFor?: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const labelSizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg',
};

export const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  (
    {
      htmlFor,
      required = false,
      disabled = false,
      size = 'md',
      children,
      className,
      testId,
      ...props
    },
    ref
  ) => {
    const baseClasses = [
      'block font-medium',
      'transition-colors duration-200',
    ];

    const sizeClasses = labelSizes[size] || labelSizes.md;

    const classes = cn(
      baseClasses,
      sizeClasses,
      {
        'text-gray-700': !disabled,
        'text-gray-400 cursor-not-allowed': disabled,
      },
      className
    );

    return (
      <label
        ref={ref}
        htmlFor={htmlFor}
        className={classes}
        data-testid={testId}
        {...props}
      >
        {children}
        {required && (
          <span className="text-error-500 ml-1" aria-label="required">
            *
          </span>
        )}
      </label>
    );
  }
);

Label.displayName = 'Label';